import React from 'react';
import { Dialog, DialogContent, IconButton, Box, Typography, GlobalStyles, useTheme } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { JsonEditor } from '../JsonEditor/JsonEditor';

interface JsonViewerDialogProps {
  open: boolean;
  onClose: () => void;
  data: Record<string, any> | null;
  title?: string;
}

export const JsonViewerDialog: React.FC<JsonViewerDialogProps> = ({ open, onClose, data, title = 'JSON Payload' }) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2.5,
          py: 1.5,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <IconButton onClick={onClose} size="small" edge="end">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 1 }}>
        <GlobalStyles
          styles={{
            '.jsoneditor, .jsoneditor-mode-view': {
              border: `1px solid ${theme.palette.divider} !important`,
            },
            '.jsoneditor-tree, .jsoneditor-frame': {
              backgroundColor: `${theme.palette.background.paper} !important`,
            },
            '.jsoneditor-field, .jsoneditor-frame input': {
              color: `${theme.palette.text.primary} !important`,
            },
            '.jsoneditor-highlight': {
              color: `${theme.palette.error.main} !important`,
            },
          }}
        />
        <JsonEditor
          name="json-viewer"
          value={data || {}}
          onChange={() => {}} // Read-only
          disabled={true}
          height="60vh"
        />
      </DialogContent>
    </Dialog>
  );
};

export default JsonViewerDialog;
